<template>
    <img src="/images/promo/hero-section/bookmark-tabs.png"
     alt="Bookmark tabs" />
</template>

<script>
export default {};
</script>
